"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'socialMediaPlan.tab.posts': 'Posty',
    'socialMediaPlan.tab.calendar': 'Harmonogram',
    'socialMediaPlan.tab.history': 'Historia',
};
